export default __webpack_public_path__ + "static/Gibson-Light-7d0506115dd6d9dc83e3403b8189d510.woff2";